import { Typography, useTheme } from '@mui/material';
import { upperFirst } from 'lodash-es';

import { useLocale } from '@repo/i18n';

interface IProps {
    capacity: number;
    fewLeft: number;
    showRemaining?: boolean;
    px?: number;
    disableMinWidth?: boolean;
    hasWaitingList?: boolean;
    isClosedForBooking?: boolean;
}

export default function TourAvailability({
    capacity,
    fewLeft,
    showRemaining,
    px,
    disableMinWidth,
    hasWaitingList,
    isClosedForBooking,
}: IProps) {
    const theme = useTheme();
    const { t } = useLocale();

    const getCss = () => {
        if (hasWaitingList && isClosedForBooking) {
            return { backgroundColor: '#fcba2d', color: '#000 !important' };
        } else if (capacity < 1) {
            return { backgroundColor: '#C4C0C0', color: '#000 !important' };
        } else if (capacity <= fewLeft) {
            return { backgroundColor: '#fcba2d', color: '#000 !important' };
        } else {
            return { backgroundColor: '#1A744F', color: '#fff !important' };
        }
    };

    const getText = () => {
        if (hasWaitingList && isClosedForBooking) {
            return upperFirst(t.waiting_list);
        } else if (capacity < 1) {
            return upperFirst(t.sold_out);
        } else if (capacity <= fewLeft) {
            if (showRemaining) {
                return t.tickets_left.parsed(capacity, capacity);
            } else {
                return upperFirst(t.few_left);
            }
        } else {
            return upperFirst(t.available);
        }
    };

    return (
        <Typography
            component="div"
            variant="body2"
            py={0.2}
            px={px ?? 1}
            borderRadius={`${theme.shape.borderRadius}px`}
            minWidth={!disableMinWidth ? '6rem' : 'auto'}
            textAlign="center"
            fontWeight="bold"
            sx={{
                fontSize: theme.typography.pxToRem(12),
                [theme.breakpoints.down('sm')]: {
                    minWidth: !disableMinWidth ? '5rem' : 'auto',
                    fontSize: theme.typography.pxToRem(10),
                },
                display: 'inline-block',
                ...getCss(),
            }}
        >
            {getText()}
        </Typography>
    );
}
